import React, { FC } from "react";

import { isValid } from "date-fns";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { GrayCard, RefValue } from "@/components/molecules";
import { GrayCardProps } from "@/components/molecules/Cards/GrayCard/GrayCard";
import { defaultDateFormat } from "@/core/date";

import { CompanyFormType } from "../../../../formType";
import { StyledCardItem, StyledCardList } from "../styled";

const FinancialCard: FC<GrayCardProps> = ({ onEdit }) => {
    const { t } = useTranslation();
    const { getValues } = useFormContext<CompanyFormType>();
    const { fiscalStatus, endOfFiscalYear, vatNumber, vatExemption, bankAccountNumber, billingEmailAddress } =
        getValues("fiscalFinancial");

    return (
        <GrayCard title={t("Common.FinancialTax")} onEdit={onEdit}>
            <StyledCardList>
                <StyledCardItem $size={2}>
                    <span>{t("Common.FiscalStatus")}</span>
                    <span>{fiscalStatus ? <RefValue table="taxStatusMoral" value={fiscalStatus} /> : "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.EndOfFiscalYear")}</span>
                    <span>{isValid(endOfFiscalYear) ? defaultDateFormat(endOfFiscalYear, "dd/MM") : "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.VatNumber")}</span>
                    <span>{vatNumber || "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.VatExemption")}</span>
                    <span>{vatExemption || "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.AccountNumber")}</span>
                    <span>{bankAccountNumber || "-"}</span>
                </StyledCardItem>
                <StyledCardItem $size={3}>
                    <span>{t("Common.BillingEmailAddress")}</span>
                    <span>{billingEmailAddress || "-"}</span>
                </StyledCardItem>
            </StyledCardList>
        </GrayCard>
    );
};

export default FinancialCard;
